export default __webpack_public_path__ + "static/media/illustration-recruit-1-m.62b401d8.webp";